import type { OfferSheetContact as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

/**
 * The admin store's local `Contact` also declared `offerSheetId`. No schema -- legacy or
 * AppSchema -- has that field on the contact, and no selection ever asked for it, so it is
 * dropped rather than carried across.
 */
export type OfferSheetContact = {
  id: number;
  email: string;
  name: string;
  role: string;
  createdAt?: string;
  updatedAt?: string;
};

export const fromGql = (item: GQLItem): OfferSheetContact =>
  take<OfferSheetContact, GQLItem>(item, 'id', 'email', 'name', 'role', 'createdAt', 'updatedAt');
